import { useReactiveVar } from '@apollo/client';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { loginData } from '../client/apollo';
import { RegistrationStage } from '../client/generated/graphql';
import { onboardingCategorySelectionPath, onboardingWelcomePath, rootPath } from '../navigation/paths';

export const AppRouter = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const authData = useReactiveVar(loginData);

  useEffect(() => {
    // Only redirect if we have auth data
    if (!authData) return;

    const { registrationStage } = authData;
    const currentPath = location.pathname;

    // If user is JustRegistered and not already on onboarding page, redirect to onboarding
    if (registrationStage === RegistrationStage.JustRegistered 
      && currentPath !== onboardingWelcomePath
      && currentPath !== onboardingCategorySelectionPath) {
      navigate(onboardingWelcomePath, { replace: true });
    }
    // If user is Finished and currently on onboarding page, redirect to main app
    else if (registrationStage === RegistrationStage.Finished 
      && (currentPath === onboardingWelcomePath || currentPath === onboardingCategorySelectionPath)) {
      navigate(rootPath, { replace: true });
    }
  }, [authData, location.pathname, navigate]);

  return null;
}; 